<template>
  <div>
  <base-card>
    <v-card-text>
      <div class="d-flex flex-column align-center justify-center text-center py-6">
        <h3 class="mb-8">Descarga XMLS</h3>
      </div>

      <v-row>
        <v-col cols="12" sm="2"></v-col>

        <v-col cols="12" sm="4">
          <v-select
            ref="cliente"
            v-model="dataFilter.IdCompania"
            :items="filteredClients"
            item-text="text"
            item-value="IdCompania"
            label="Selecciona una compañía"
            prepend-inner-icon="mdi-sitemap"
            required
            dense
            outlined
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-text-field
                      v-model="search"
                      placeholder="Buscar"
                      prepend-inner-icon="mdi-magnify"
                      hide-details
                      dense
                    />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-col>

        <v-col cols="12" sm="4">
          <v-textarea
            v-model="dataFilter.Consecutivos"
            label="Consecutivos (separados por coma)"
            prepend-inner-icon="mdi-file-document"
            dense
            outlined
            required
            placeholder="Ej: FE123,FE124,FE130"
            rows="1"
            auto-grow
          />
        </v-col>
      </v-row>



      <v-row justify="center">
        <v-col cols="12" sm="3"></v-col>
          <v-col cols="12" sm="3">

          <v-btn
            :disabled="isLoading"
            :loading="isLoading"
            class="ma-2"
            style="background-color: rgb(204 33 40); color: white !important;"
            @click="descargarXMLs"
            block
          >
            <v-icon left>mdi-download</v-icon>
            Descargar XMLs
          </v-btn>
        </v-col>

        <v-col cols="12" sm="4">

          <v-btn
            :disabled="loading && files.length === 0"
            class="ma-2"
            color="gray"
            @click="clearFields"
          >
            Limpiar
          </v-btn>
        </v-col>

      </v-row>
      <v-row justify="center" class="my-4">
        <v-progress-linear
          v-if="isLoading"
          class="my-4"
          color="primary"
          indeterminate
        ></v-progress-linear>
        <v-col cols="12" sm="6">
          <v-alert
            v-if="showAlert"
            :type="alertType"
            dense
            outlined
            border="left"
            colored-border
            class="my-4"
          >
            {{ alertMessage }}
          </v-alert>

        </v-col>
      </v-row>
    </v-card-text>
  </base-card>


  </div>
</template>

<script>
import axios from 'axios';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { environment } from '@/data/environment';

export default {
  data() {
    return {
      detailClients: [],
      dataFilter: {
        IdCompania: null,
        Consecutivos: '',
      },
      search: '',
      isLoading: false,
      showAlert: false,
      alertMessage: '',
      alertType: 'success',

    };
  },
  mounted() {
    this.obtenerCompanias();
  },
  computed: {
    filteredClients() {
      const query = this.search.toLowerCase();
      return this.detailClients.filter(c =>
        c.text.toLowerCase().includes(query)
      );
    },
  },
  methods: {
    async obtenerCompanias() {
      try {
        const response = await axios.get(environment.HIOPOSWEBSERVICES + '/api/getClients');
        this.detailClients = response.data.Mensaje.map(c => ({
          text: " [ " + c.IdCompania +  " ] " +  c.NombreCompania,
          IdCompania: c.IdCompania,
        }));
      } catch (error) {
        console.error('Error al obtener compañías:', error);
      }
    },

    async descargarXMLs() {
      this.resetAlert();

      const consecutivos = this.dataFilter.Consecutivos
        .split(',')
        .map(c => c.trim())
        .filter(Boolean);

      if (!this.dataFilter.IdCompania || consecutivos.length === 0) {
        this.setAlert('warning', 'Por favor selecciona una compañía y escribe al menos un consecutivo.');
        return;
      }

      if (consecutivos.length > 50) {
        this.setAlert('warning', 'Solo se permiten hasta 50 consecutivos.');
        return;
      }

      this.isLoading = true;

      try {
        const response = await axios.post(`${environment.HIOPOSWEBSERVICES}/api/getXMLS`, {
          compania: this.dataFilter.IdCompania,
          consecutivos,
        });

        const data = response.data;

        if (data.error || !Array.isArray(data.Mensaje)) {
          throw new Error('Respuesta inválida del servidor.');
        }

        const zip = new JSZip();

        data.Mensaje.forEach((item, index) => {
          const nombre = item.CosecutivoDocumento || `archivo_${index + 1}`;
          if (item.xml) zip.file(`${nombre}.xml`, item.xml);
        });

        if (Object.keys(zip.files).length === 0) {
          this.setAlert('warning', 'No se encontraron resultados para los datos proporcionados.');
          return;
        }

        const blob = await zip.generateAsync({ type: 'blob' });
        const now = new Date().toISOString().split('.')[0].replace(/[-:T]/g, '');
        saveAs(blob, `xmls_${this.dataFilter.IdCompania}_${now}.zip`);

        this.setAlert('success', 'La descarga se realizó exitosamente.');
        this.clearFields();

      } catch (error) {
        console.error('Error al descargar XMLs:', error);
        this.setAlert('error', 'Ocurrió un error durante la descarga.');
      } finally {
        this.isLoading = false;
      }
    },

    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },

    resetAlert() {
      this.alertMessage = '';
      this.alertType = 'success';
      this.showAlert = false;
    },

    clearFields() {
      this.dataFilter = {
        IdCompania: null,
        Consecutivos: '',
      };
      this.search = '';
    },
  },
};
</script>
